var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-container"},[_c('ui-row',{attrs:{"align-h":"center"}},[_c('ui-col',{attrs:{"lg":10}},[_c('ui-card',[_c('editor',{ref:"editor"})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }